var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 12.625C9.96049 12.625 12.8333 9.88274 12.8333 6.5C12.8333 3.11726 9.96049 0.375 6.41667 0.375C2.87284 0.375 0 3.11726 0 6.5C0 9.88274 2.87284 12.625 6.41667 12.625Z",
    fill: "#EA001B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5827 12.625C19.1265 12.625 21.9993 9.88274 21.9993 6.5C21.9993 3.11726 19.1265 0.375 15.5827 0.375C12.0389 0.375 9.16602 3.11726 9.16602 6.5C9.16602 9.88274 12.0389 12.625 15.5827 12.625Z",
    fill: "#FFA200",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/Master.2d9c043c2dc20e2a13165f5190fb21fc.svg";
export { ForwardRef as ReactComponent };